/*
  Высота первого экрана для мобильного героя.

  Значение живёт в CSS-переменной --hero-h на <html>. Первую запись
  делает инлайн-скрипт в public/index.html — синхронно и до стилей,
  чтобы первый кадр отрисовался правильной высоты. Дальше правит этот
  модуль.

  Почему innerHeight, а не 100svh: svh — высота экрана с показанными
  панелями браузера, и при системном баннере Safari отдаёт его заметно
  меньше видимой области (замерено: 562 при viewport 676).

  Каждое изменение пишется в window.__heroH — историю показывает
  отладочная плашка ?hero-debug=1. Без неё нельзя понять, кто и когда
  переставил высоту: head-скрипт, монтирование или поворот экрана.
*/
export const HERO_H_VAR = "--hero-h";
// Сколько записей истории храним: плашка показывает последние шесть.
const HISTORY_LIMIT = 24;

// 100svh меряем живым элементом: по нему видно, насколько единица
// расходится с innerHeight на этом экране.
const measureSvh = () => {
  try {
    const host = document.body || document.documentElement;
    const el = document.createElement("div");
    el.style.cssText =
      "position:absolute;top:0;left:0;width:1px;height:100svh;visibility:hidden;pointer-events:none";
    host.appendChild(el);
    const h = Math.round(el.getBoundingClientRect().height);
    el.remove();
    return h;
  } catch (e) {
    return null;
  }
};

export const readHeroHeight = () => {
  const raw = document.documentElement.style.getPropertyValue(HERO_H_VAR);
  const value = parseFloat(raw);
  return Number.isFinite(value) ? value : null;
};

/*
  Ставит высоту и дописывает запись в историю. Возвращает true, если
  значение действительно изменилось.
*/
export const setHeroHeight = (source) => {
  const root = document.documentElement;
  const next = window.innerHeight;
  const current = readHeroHeight();
  root.style.setProperty(HERO_H_VAR, `${next}px`);

  const list = Array.isArray(window.__heroH) ? window.__heroH : (window.__heroH = []);
  list.push({
    t: Math.round(performance.now()),
    source,
    value: next,
    innerHeight: next,
    visualViewport: window.visualViewport ? Math.round(window.visualViewport.height) : null,
    svh: measureSvh(),
  });
  if (list.length > HISTORY_LIMIT) list.splice(0, list.length - HISTORY_LIMIT);

  return current !== next;
};
